import React, { useState } from "react";
import { tokenRef } from "api";

// BIDS — its own package in the drawer, before Projects (owner 2026-10-29).
// The Bids pages are served by the separate Rust service under /bids, so these
// are plain links (not react-router): the SPA must not catch them. The service
// reads the session from the auth cookie; it is refreshed from the stored
// token on the way out, so a company switch is seen there too.
export const BIDS_NAV = [
  { key: "overview", title: "Overview", path: "/bids" },
  { key: "post", title: "Post a bid request", path: "/bids/post" },
  { key: "postings", title: "My postings & proposals", path: "/bids/postings" },
  { key: "contractors", title: "Find contractors", path: "/bids/contractors" },
  { key: "work", title: "Find work", path: "/bids/work" },
  { key: "messages", title: "Messages", path: "/bids/messages" },
  { key: "contracts", title: "Contracts", path: "/bids/contracts" },
  { key: "timesheets", title: "Timesheets", path: "/bids/timesheets" },
  { key: "payments", title: "Payments & fees", path: "/bids/payments" },
];

export function bidsCookieName() {
  return String(tokenRef).startsWith("prebidlight") ? "prebidlight" : "bidlight";
}

export function syncBidsSession() {
  try {
    const token = localStorage.getItem(tokenRef);
    if (token) {
      document.cookie = `${bidsCookieName()}=${token}; path=/; secure; samesite=lax; max-age=${30 * 24 * 3600}`;
    }
  } catch (e) {
    /* storage unavailable: the cookie set at login still applies */
  }
}

export function BidsDrawerEntry() {
  const [open, setOpen] = useState(false);
  return (
    <div data-testid="drawer-bids">
      <h5 className="mb-0">
        <button
          className="sidebar-collapse-btn bg-white"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
        >
          <div className="sidebar-list">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M3 21h12v-2H3v2zM7.24 8.07l2.83-2.83 14.14 14.14-2.83 2.83L7.24 8.07zM12.9 2.42l5.66 5.66-2.83 2.83-5.66-5.66 2.83-2.83zM3.71 11.29l5.66 5.66-2.83 2.83L.88 14.12l2.83-2.83z"
                fill="#000"
              />
            </svg>
            <p className="ml-1">Bids</p>
            <span className="ml-auto pr-2">{open ? "▾" : "▸"}</span>
          </div>
        </button>
      </h5>
      {open && (
        <ul className="siderbar-inner-ul mb-0" style={{ paddingLeft: 44 }}>
          {BIDS_NAV.map((entry) => (
            <li key={entry.key}>
              <a href={entry.path} className="mb-0 text-decoration-none" onClick={syncBidsSession}>
                {entry.title}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
